<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{dialogTitle}}</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 pb-0 m-0" fusePerfectScrollbar>
        <form name="containerModalForm" [formGroup]="containerModalForm" class="container-modal-form w-100-p">
            <div formArrayName="volume" fxLayout="column" fxLayoutAlign="center">
                <div *ngFor="let item of containerModalForm.get('volume')['controls']; let i=index" [formGroupName]="i" fxLayout="row wrap" fxLayoutAlign="center">
                  <mat-form-field appearance="outline" floatLabel="always" 
                    class="pr-8" fxFlex="50">
                    <mat-label>Quantity</mat-label>
                    <input type="number" matInput formControlName="quantity" min="0" required>
                    <mat-error *ngIf="containerModalForm.controls.volume.controls[i].get('quantity').hasError('required')">
                      Quantity is required
                    </mat-error>
                    <mat-error *ngIf="!containerModalForm.controls.volume.controls[i].get('quantity').hasError('required') &&
                                containerModalForm.controls.volume['controls'][i].get('quantity').value <= 0">
                        Quantity > 0;
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" floatLabel="always" 
                    class="pr-8" fxFlex="50">
                    <mat-label>Unit Type</mat-label>
                    <input matInput name="name" formControlName="name" required [readonly]="true">
                    <mat-icon matSuffix class="disabled-text" (click)="removeUnit(i)" style="cursor: pointer;">close</mat-icon>
                    <mat-error *ngIf="containerModalForm.controls.volume.controls[i].get('name').hasError('required')">
                      Type is required
                    </mat-error>
                  </mat-form-field>
                </div>
            </div>
            <div fxLayout="column" fxLayoutAlign="center">
                <div fxLayout="row" fxLayoutAlign="center">
                    <mat-form-field appearance="outline" class="pr-sm-8" fxFlex="50">
                        <mat-label>List type</mat-label>
                        <mat-select name="type" formControlName="type" style="margin-top: -4px">
                            <mat-option *ngFor="let item of unit" [value]="item">
                              {{item.code}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="pr-sm-8" fxFlex="50" fxLayoutAlign="center center">
                        <button mat-flat-button color="accent" (click)="addUnit(containerModalForm.controls.type.value)" [disabled]="!containerModalForm.controls.type.valid"><mat-icon>add</mat-icon></button>
                    </div>
                </div>
            </div>
        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="center center">
        <button *ngIf="dialogTitle == 'Volume'"
            mat-raised-button 
            color="accent" 
            (click)="matDialogRef.close(containerModalForm.value)" 
            [disabled]="containerModalForm.invalid || checkNum == 0">OK</button>
    </div>
</div>
